import { useEffect, useState } from "react";
import Layout from "../Layout";
import DirectIcon from "../../assets/images/svg-icons-material-io/mail_lock_FILL0_wght400_GRAD0_opsz48.svg";
import OrgIcon from "../../assets/images/svg-icons-material-io/domain_FILL0_wght400_GRAD0_opsz48.svg";
import ReceivedMsgIcon from "../../assets/images/svg-icons-material-io/markunread_mailbox_FILL0_wght400_GRAD0_opsz48.svg";
import HeaderDashboard from "./HeaderDashboard";
import SubMenu from "../nav-admin/SubMenu/SubMenu";
import { Link, useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { usePortalAuthentication } from "../../services/authorizationService";

const Dashboard = () => {
  const {
    userRole,
    userToken,
    sharedObject,
    setUserSession,
    setSearchObj,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    setUserSession: state.setUserSession,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const [obj, setObj] = useState(false);
  const [flag, setFlag] = useState(false);
  const [processing, SetProcessing] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const navigate = useNavigate();
  const { logout } = usePortalAuthentication();
  const [emailCount, setEmailCount] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (userRole === "User") {
        logout();
      }
      //getOrgList();
      SetProcessing(true);
      let call = "/dashboard/GetDashboard";
      const res = await CallAPI(call, null, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res && res.status === "SUCCESS") {
        setObj(res.data);
        SetProcessing(false);
      } else if (res.status === "SERVERERROR") {
        let str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
        SetMsg(str);
        SetErrMsg(true);
        SetProcessing(false);
      }
      if (userRole !== "SES ADMINISTRATOR") {
        getDomains();
      }
    };
    fetchData();
  }, []);

  // const getOrgList = async () => {

  //     let obj = { VendorId: userSession.vendor_id };
  //     let call = "/organization/OrgSearchEngine";
  //     const res = await CallAPI(call, obj, "post", userToken);
  //     if (res.status === "SUCCESS") {
  //         getEmailCount(res.data);
  //     }
  // }
  // const getEmailCount = async (orgs) => {
  //     var count = 0;
  //     let call = "/emails/SearchEmails";
  //     for (var i = 0; i < orgs.data.length; i++) {
  //         let obj = { OrganizationId: orgs.data[i].id };
  //         const res = await CallAPI(call, obj, "post", userToken);
  //         if (res.status === "SUCCESS") {
  //             count = count + res.data.data.length;
  //         }
  //     }
  //     setEmailCount(count.toString());
  // }
  const getDomains = async () => {
    SetProcessing(true);
    SetErrMsg(false);
    let call = "/customers/GetUserDomains";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      let getDomain = res.data.data;
      let dmId = null;
      let dmName = null;
      if (getDomain.length === 1) {
        dmId = parseInt(getDomain[0].value);
        dmName = getDomain[0].text;
      } else {
        for (let dm of getDomain) {
          if (dm.text === userSession.domain_name) {
            dmId = dm.value;
            dmName = dm.text;
            break;
          }
        }
      }
      setUserSession({ ...userSession, domain_id: dmId, domain_name: dmName });
    } else if (res.status === "SERVERERROR") {
      let str =
        "A system error occurred searching for your results. Please contact support for further assistance.";
      SetMsg(str);
      SetErrMsg(true);
      SetProcessing(false);
    }
  };
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);
  function isEmpty(value) {
    return (
      value == null || (typeof value === "string" && value.trim().length === 0)
    );
  }
  return (
    <Layout>
      {userRole !== "SES ADMINISTRATOR" &&
      userRole !== "ADMINISTRATOR" ? null : (
        <HeaderDashboard />
      )}
      {errMsg ? (
        <div className="alert alert-danger" role="alert">
          {msg}
        </div>
      ) : null}
      <section className="dashboard-container">
        {userRole !== "SES ADMINISTRATOR" ? (
          <Link
            onClick={(el) => {
              if (window !== "undefined") {
                if (
                  sharedObject.getUserEmails &&
                  sharedObject.getUserEmails.length > 0
                ) {
                  window.open("../webmail", "_self");
                } else {
                  setFlag("/no-direct-email");
                }
              }
            }}
            className="btn btn-primary dash-box box-direct animate slide delay-1"
            title="Direct Webmail"
            alt="Navigate to Direct webmail"
          >
            <div className="box-icon">
              <img
                src={DirectIcon}
                className="filter-white"
                alt="Email Lock Icon"
                title="Direct Email"
              />
            </div>
            <div className="box-bottom">
              <div className="title">Direct</div>
              <div className="sub-title">Webmail</div>
            </div>
          </Link>
        ) : null}

        {/* Organizations Box*/}
        <Link
          onClick={(el) => {
            setSearchObj([]);
            SetSharedObject("xdrSettiingObj", {});
            SetSharedObject("custumerRecord", {});
            SetSharedObject("orgActionObj", false);
            setFlag("/organizations");
          }}
          className="btn btn-primary dash-box box-org animate slide delay-2"
          title="Organizations"
          alt="Navigate to manage organizations"
        >
          <div className="box-icon">
            <img
              src={OrgIcon}
              className="filter-white"
              alt="Building Icon"
              title="Organizations"
            />
          </div>
          <div className="box-bottom">
            <div className="title">Organizations</div>
            <div className="sub-title">
              Total:{" "}
              {userRole === "SES ADMINISTRATOR"
                ? obj?.data?.totalAdminOrgCount
                : sharedObject?.getOrgsObj?.length}
            </div>
          </div>
        </Link>

        {/*Users Box*/}
        <Link
          onClick={(el) => {
            SetSharedObject("UserIdEmail", {});
            setFlag("/users");
          }}
          className="btn btn-primary dash-box box-users animate slide delay-3"
          title="Users"
          alt="Navigate to mange users"
        >
          <div className="box-icon">
            <i className="bi bi-people" title="Users Title"></i>
          </div>
          <div className="box-bottom">
            <div className="title">Users</div>
            <div className="sub-title">
              Total: {obj?.data?.totalAdminUserCount}
            </div>
          </div>
        </Link>
        <Link
          className="btn btn-primary dash-box box-customer animate slide delay-8"
          aria-labelledby="Button to Email Page"
          onClick={(el) => {
            SetSharedObject("UserIdEmail", {});
            setFlag("/emails");
          }}
        >
          <div className="box-icon">
            <i className="bi bi-envelope-at-fill" title="Users Title"></i>
          </div>
          <div className="box-bottom">
            <div className="title">Emails</div>
            <div className="sub-title"></div>
          </div>
        </Link>
        {/*Sent Message Reports Box*/}
        <Link
          onClick={(el) => {
            SetSharedObject("sentMessageStatusResults", {});
            SetSharedObject("messageStatusSearch", {});
            SetSharedObject("SentSearchType", "");
            setFlag("/sent-message");
          }}
          className="btn btn-primary dash-box box-sentmsg animate slide delay-4"
          title="Sent Message Reports"
          alt="Navigate to sent message reports"
        >
          <div className="box-icon">
            <i className="bi bi-send-check"></i>
          </div>
          <div className="box-bottom">
            <div className="title">Sent Message</div>
            <div className="sub-title">Reports</div>
          </div>
        </Link>
        {/*Received Message Reports Box*/}
        <Link
          onClick={(el) => {
            SetSharedObject("recievedMessageStatusResults", {});
            SetSharedObject("messageStatusSearch", {});
            SetSharedObject("SentSearchType", "");
            setFlag("/received-message");
          }}
          className="btn btn-primary dash-box box-receivedmsg animate slide delay-5"
          title="Received Message Reports"
          alt="Navigate to received message reports"
        >
          <div className="box-icon">
            <img
              src={ReceivedMsgIcon}
              className="filter-white"
              alt="Received Messages Icon"
            />
          </div>
          <div className="box-bottom">
            <div className="title">Received Message</div>
            <div className="sub-title">Reports</div>
          </div>
        </Link>
        {/*Download Status Box*/}
        <Link
          to={"/download-status"}
          className="btn btn-primary dash-box box-status animate slide delay-6"
          aria-labelledby="Button to Download Status"
        >
          <div className="box-icon">
            <i className="bi bi-download"></i>
          </div>
          <div className="box-bottom">
            <div className="title">Download Status</div>
            <div className="sub-title">Reports</div>
          </div>
        </Link>
        {/*User Reports Box*/}
        <button
          className="btn btn-primary dash-box box-reports animate slide delay-7"
          data-toggle="collapse"
          type="button"
          data-target="#btnUserReport"
          onClick={(el) => {
            SetSharedObject("UserActiviySearch", {});
          }}
          aria-expanded="false"
          aria-controls="UserReportsSubmenus"
        >
          <div className="box-icon">
            <i className="bi bi-file-bar-graph"></i>
          </div>
          <div className="box-bottom">
            <div className="title">User</div>
            <div className="sub-title">Reports</div>
          </div>
        </button>

        {/*Customers Box*/}
        {userRole !== "SES ADMINISTRATOR" ? null : (
          <Link
            to={"/customers"}
            className="btn btn-primary dash-box box-customer animate slide delay-8"
            aria-labelledby="Button to Customers"
          >
            <div className="box-icon">
              <i className="bi bi-globe2"></i>
            </div>
            <div className="box-bottom">
              <div className="title">Customers</div>
              <div className="sub-title"></div>
            </div>
          </Link>
        )}
      </section>
      <SubMenu />
      {processing ? <div className="loading"></div> : null}
    </Layout>
  );
};

export default Dashboard;
